export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                /* {
                    title: 'Expediente',
                    type: 'custom-html',
                    key: 'record',
                    modifier: (value, row) => {
                        return `<a href="/accreditations/applications/${row.id}" target="_blank">${value || ''}</a>`;
                    }
                }, */
                {
                    title: 'Expediente',
                    type: 'custom-html',
                    key: 'record',
                    modifier: (value) => {
                        return value;
                    }
                },
                {
                    title: this.$t('area'),
                    type: 'custom-html',
                    key: 'accreditation_area',
                    modifier: (value) => {
                        return value.name;
                    }
                },
                {
                    title: this.$t('activity'),
                    type: 'custom-html',
                    key: 'accreditation_activity',
                    modifier: (value) => {
                        return value.name;
                    }
                },
                {
                    title: this.$t('type'),
                    type: 'custom-html',
                    key: 'accreditation_type',
                    modifier: (value) => {
                        return value.name;
                    }
                },
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'organization',
                    modifier: (value) => {
                        return value.business_name;
                    }
                },
                /* {
                    title: this.$t('status'),
                    type: 'custom-html',
                    key: 'status',
                    modifier: (value) => {
                        let className;
                        let status;

                        if (value.code == '100') {
                            className = 'warning';
                            status = value.name;
                        } else if (['112', '116', '109'].includes(value.code)) {
                            className = 'danger';
                            status = value.name;
                        } else {
                            className = 'success';
                            status = value.name;
                        }

                        return `<span class="badge badge-sm badge-pill badge-${className}">${status}</span>`;
                    }
                }, */
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}